var MainNavigation = /** @class */ (function () {
    function MainNavigation() {
        var _this = this;
        this.header = document.querySelector('[data-header]');
        this.mainNavigation = this.header.querySelector('.header-main');
        this.menuItems = this.mainNavigation.querySelectorAll('.menu-item');
        this.secondaryMenuContainer = this.header.querySelector('.secondary-menu');
        this.secondaryMenuItemWrappers = this.secondaryMenuContainer.querySelectorAll('.row');
        this.pageOverlay = document.querySelector('[data-page-overlay]');
        var zIndex = getComputedStyle(document.body).zIndex;
        if (zIndex == "3") {
            this.addEventListeners();
        }
        window.addEventListener('resize', function () {
            if (zIndex == "3") {
                _this.addEventListeners();
            }
        });
    }
    MainNavigation.prototype.addEventListeners = function () {
        var _this = this;
        this.header.addEventListener('mouseleave', function () { return _this.closeDropdown(); });
        this.menuItems.forEach(function (toggle) {
            if (toggle.classList.contains('menu-item-has-children')) {
                toggle.addEventListener('mouseenter', function () { return _this.openDropdown(toggle); });
            }
            else {
                toggle.addEventListener('mouseenter', function () { return _this.closeDropdown(); });
            }
        });
        document.querySelector('.header-top').addEventListener('mouseenter', function () { return _this.closeDropdown(); });
        this.secondaryMenuContainer.addEventListener('mouseleave', function () { return _this.closeDropdown(); });
    };
    MainNavigation.prototype.openDropdown = function (toggle) {
        var parentElement = toggle.getAttribute('id');
        this.secondaryMenuItemWrappers.forEach(function (menuContainer) { return menuContainer.classList.remove('active'); });
        this.secondaryMenuContainer.querySelector("[data-menu-parent=\"".concat(parentElement, "\"]")).classList.add('active');
        this.header.classList.add('active');
        this.menuItems.forEach(function (toggle) { return toggle.classList.remove('active'); });
        toggle.classList.add('active');
        this.pageOverlay.classList.add('visible');
    };
    MainNavigation.prototype.closeDropdown = function () {
        this.secondaryMenuContainer.classList.remove('active');
        this.secondaryMenuItemWrappers.forEach(function (menuContainer) { return menuContainer.classList.remove('active'); });
        this.menuItems.forEach(function (toggle) { return toggle.classList.remove('active'); });
        this.header.classList.remove('active');
        this.pageOverlay.classList.remove('visible');
    };
    return MainNavigation;
}());
export default MainNavigation;
